<template>
    <div>
        <div>
            <el-button type="primary" @click="handleClickChannelDialog">创建渠道</el-button>
        </div>
        <el-table :data="datalist">
            <el-table-column prop="id" label="渠道id" />
            <el-table-column prop="tag" label="渠道标签" />
            <el-table-column prop="name" label="渠道名称" />
            <el-table-column prop="remark" label="渠道备注" />
            <el-table-column label="佣金率模板">
                <template slot-scope="scope">
                    <div>id：{{scope.row.settlement_rate_template.id}}</div>
                    <div>名称：{{scope.row.settlement_rate_template.name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="税率模板">
                <template slot-scope="scope">
                    <div>id：{{scope.row.tax_rate_template.id}}</div>
                    <div>名称：{{scope.row.tax_rate_template.name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="PC端邀请URL">
                <template slot-scope="scope">
                    <span v-if="scope.row.type">{{ scope.row.pc_url1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="h5端邀请URL">
                <template slot-scope="scope">
                    <span v-if="scope.row.type">{{ scope.row.h5_url1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" type="primary" @click="getChannelURL(scope.row)" v-if="scope.row.id !== '0'">生成渠道链接</el-button>
                        <el-button size="mini" type="primary" @click="handleUpdateChannel(scope.row)" v-if="scope.row.id !== '0'">更新</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="50"
            :pageSizes="pageSizes"
            :currentPageCount="datalist.length"
            @page-changed="loadData"
        ></page-bar>

        <el-dialog title="创建渠道" :visible.sync="createChannelDialogShow">
            <el-form label-position="right">
                <el-form-item label="渠道标签：" label-width="150px">
                    <el-input v-model="newChannel.tag" placeholder="请输入渠道标签"></el-input>
                </el-form-item>
                <el-form-item label="渠道名称：" label-width="150px">
                    <el-input v-model="newChannel.name" placeholder="请输入渠道名称"></el-input>
                </el-form-item>
                <el-form-item label="渠道备注：" label-width="150px">
                    <el-input v-model="newChannel.remark" placeholder="请输入渠道备注"></el-input>
                </el-form-item>
                <el-form-item label="佣金率模板id：" label-width="150px">
                    <el-select v-model="newChannel.settlement_rate_template_id" placeholder="请选择" class="policy-box-input" style="width: 100%;">
                        <el-option
                            v-for="(opt, index) in settlement"
                            :key="index"
                            :label="`ID: ${opt.id}   名称: ${opt.name}`"
                            :value="opt.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="税率模板id：" label-width="150px">
                    <el-select v-model="newChannel.tax_rate_template_id" placeholder="请选择" class="policy-box-input" style="width: 100%;">
                        <el-option
                            v-for="(opt, index) in tax"
                            :key="index"
                            :label="`ID: ${opt.id}   名称: ${opt.name}`"
                            :value="opt.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="pc_url：" label-width="150px">
                    <el-input v-model="newChannel.pc_url" placeholder="请输入PC链接"></el-input>
                </el-form-item>
                <el-form-item label="h5_url：" label-width="150px">
                    <el-input v-model="newChannel.h5_url" placeholder="请输入H5链接"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createChannelDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="createChannel">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import PageBar from "@/modules/ui/PageBar";
import request from "@/api/request";

export default {
    components: {
        PageBar
    },
    data(){
        return{
            datalist: [],
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            createChannelDialogShow: false,
            newChannel: {
                tag: '',
                name: '',
                remark: '',
                pc_url: '',
                h5_url: '',
                settlement_rate_template_id: '',
                tax_rate_template_id: ''
            },
            settlement: [], 
            tax: []
        }
    },
    created() {
        this.loadData([0, 50])
        this.getRateList()
    },
    methods: {
        getRateList(){
            request.saas
                .post('settlement/get_settlement_rate_template_list', {
                    range: [0, 100],
                })
                .then(r => {
                    this.settlement = r.data.list
                })
            request.saas
                .post('settlement/get_tax_rate_template_list', {
                    range: [0, 100],
                })
                .then(r => {
                    this.tax = r.data.list
                })
        },
        loadData(range){
            this.currentRange = range
            request.saas
                .post('uc/invite/get_channel_list', {
                    range: range
                })
                .then(r => {
                    r.data.list.map((item) => item.type = false)
                    this.datalist = r.data.list
                })
        },
        createChannel(){
            if(this.newChannel.id) {
                //更新
                request.saas
                    .post('uc/invite/update_channel', this.newChannel)
                    .then(() => {
                        this.loadData(this.currentRange)
                        this.createChannelDialogShow = !this.createChannelDialogShow
                    })
            } else {
                //创建
                request.saas
                    .post('uc/invite/create_channel', this.newChannel)
                    .then(() => {
                        this.loadData(this.currentRange)
                        this.createChannelDialogShow = !this.createChannelDialogShow
                    })
            }
            
        },
        handleUpdateChannel(row) {
            this.newChannel = {
                id: row.id,
                tag: row.tag,
                name: row.name,
                remark: row.remark,
                pc_url: row.pc_url,
                h5_url: row.h5_url,
                settlement_rate_template_id: row.settlement_rate_template.id,
                tax_rate_template_id: row.tax_rate_template.id
            }
            console.log(this.newChannel)
            this.createChannelDialogShow = !this.createChannelDialogShow
        },
        getChannelURL(item){
            request.saas
                .post('uc/invite/get_channel_url', {
                    channel_id: item.id
                })
                .then(r => {
                    item.pc_url1 = r.data.pc_url
                    item.h5_url1 = r.data.h5_url
                    item.type = true
                })
        },
        handleClickChannelDialog(){
            this.newChannel = {
                tag: '',
                name: '',
                remark: '',
                pc_url: '',
                h5_url: ''
            }
            this.createChannelDialogShow = !this.createChannelDialogShow
        }
    }
}
</script>
<style scoped>
.edit-btn-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

}
.edit-btn-box .el-button{
    margin-bottom: 5px;
    margin-left: 0;
    min-width: 110px;
}
</style>
